import { Injectable } from '@angular/core';
import { TableDataApiParams } from '@services/practices.service';
import { GaragePassage } from '@/models/garage-passage.model';
import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';
import { GaragePassageService } from '@services/garage-passage.service';

@Injectable({
  providedIn: 'root',
})
export class GaragePassagesDataSource extends DataSourceBaseNew<GaragePassage> {
  constructor(private garagePassageService: GaragePassageService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    this._isLoading$.next(true);
    this.garagePassageService.getElements(params).subscribe((data) => {
      this.elements$.next(data.content);
      this._totalElements$.next(data.totalElements);
      this._isLoading$.next(false);
    });
  }
}
